var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Map"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 3.74194H8C6.67392 3.74194 5.40215 4.26873 4.46447 5.20641C3.52678 6.14409 3 7.41586 3 8.74194V16.7419C3 18.068 3.52678 19.3398 4.46447 20.2775C5.40215 21.2152 6.67392 21.7419 8 21.7419H16C17.3261 21.7419 18.5979 21.2152 19.5355 20.2775C20.4732 19.3398 21 18.068 21 16.7419V12.7419",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 5.74194L19 20.7419",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4 19.7419L11 12.7419",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.7813 4.60424C18.0283 4.60523 18.2695 4.67938 18.4744 4.81733C18.6793 4.95528 18.8387 5.15084 18.9326 5.37933C19.0264 5.60782 19.0504 5.85899 19.0016 6.10113C18.9528 6.34327 18.8334 6.56553 18.6584 6.73984C18.4834 6.91415 18.2606 7.0327 18.0183 7.08053C17.776 7.12836 17.5249 7.10331 17.2968 7.00856C17.0687 6.91381 16.8737 6.7536 16.7366 6.54815C16.5995 6.3427 16.5263 6.10123 16.5263 5.85422C16.5254 5.6894 16.5573 5.52605 16.6201 5.37367C16.6829 5.22129 16.7754 5.08292 16.8922 4.96661C17.009 4.8503 17.1477 4.75836 17.3004 4.69615C17.453 4.63395 17.6165 4.6027 17.7813 4.60424Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.5468 5.89047C21.5468 4.88971 21.1492 3.92994 20.4416 3.22229C19.7339 2.51465 18.7741 2.1171 17.7734 2.1171C16.7726 2.1171 15.8128 2.51465 15.1052 3.22229C14.3976 3.92994 14 4.88971 14 5.89047C14 7.91772 15.9277 9.54398 17.0273 10.4771C17.238 10.6484 17.5013 10.742 17.7728 10.742C18.0444 10.742 18.3077 10.6484 18.5183 10.4771C19.6191 9.54397 21.5468 7.88647 21.5468 5.89047Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgMapV2;